import { useMemo } from 'react'

import { useDirectReportAssessmentAverages } from '../services/users.convex'
import { processLatestData } from '../utils/positionRadarChart.utils'
import { PositionRadarChart } from './PositionRadarChart'

interface Props {
  userId: string
}

/**
 * Radar chart for a direct report, sourced from Convex.
 *
 * Accepts a Convex user _id (not a Kinde/Postgres UUID).
 */
export function ConvexDirectReportPositionRadarChart({ userId }: Props) {
  const {
    data: timeseries,
    isLoading,
    error,
  } = useDirectReportAssessmentAverages(userId, true)

  const chartData = useMemo(() => processLatestData(timeseries), [timeseries])

  return (
    <PositionRadarChart data={chartData} isLoading={isLoading} error={error} />
  )
}
